import "../UserVerification/UserVerification.css";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import { MenuItem, TextField } from "@mui/material";
import { Preferences } from "@capacitor/preferences";
import axios from "axios";

// Components
import IonicPageWrapper from "../../components/IonicPageWrapper/IonicPageWrapper";
import StandardButton from "../../components/StandardButton/StandardButton";
import StandardTextfield from "../../components/StandardTextfield/StandardTextfield";

function Login() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [uniquetext, setuniquetext] = useState("");

  const [loginData, setLoginData] = useState({
    // first_name: "",
    phone_no: "",
    classid: "",
  });

  const [btnLoading, setBtnLoading] = useState(false);
  const [allClassData, setAllClassData] = useState([]);

  useEffect(() => {
    fetchAllClass();
  }, []);

  const fetchAllClass = async () => {
    const { value } = await Preferences.get({
      key: "gjaai_user_schoolid",
    });
    const text = await Preferences.get({ key: "gjaii_unique_text" });
    setuniquetext(text.value);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/getclassesbyschoolid`,
        { schoolid: value }
      );

      if (res.data.success) {
        setAllClassData(res.data.data);
      } else {
        enqueueSnackbar("Error Fetching Class", { variant: "error" });
      }
    } catch (err) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { first_name, phone_no, classid } = loginData;

    if (!phone_no || !classid) {
      return enqueueSnackbar("Please fill all details", {
        variant: "error",
      });
    }

    setBtnLoading(true);

    try {
      const payload = {
       
        phone_no,
        classid,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/studentlogin`,
        payload
      );

      if (res.data.success) {
        enqueueSnackbar("Login Successful", { variant: "success" });
        console.log(res.data.student);

        Preferences.set({
          key: "gjaii_IDCARD_user",
          value: JSON.stringify(res.data.student),
        });

        Preferences.set({
          key: "userMobile",
          value: phone_no,
        });

        history.push("/home");
        setBtnLoading(false);
        return;
      }

      enqueueSnackbar(res.data.message || "Login Failed", {
        variant: "error",
      });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Login error, try again", {
        variant: "error",
      });
    }

    setBtnLoading(false);
  };

  return (
    <IonicPageWrapper headerTitle="Student Login">
      <div id="verification">
        <section className="verification_cont">
          <form className="verification_form" onSubmit={handleSubmit}>
            <div>
              {/* <StandardTextfield
                variant="outlined"
                label="Name"
                name="first_name"
                value={loginData.first_name}
                setValue={setLoginData}
                spreadValue={loginData}
              /> */}
              <StandardTextfield
                variant="outlined"
                label={uniquetext ? `${uniquetext} ` : "Enter Unique ID"}
                type="text"
                name="phone_no"
                value={loginData.phone_no}
                setValue={setLoginData}
                spreadValue={loginData}
              />

              <TextField
                fullWidth
                select
                label="Select Class"
                value={loginData.classid}
                onChange={(e) =>
                  setLoginData({
                    ...loginData,
                    classid: e.target.value,
                  })
                }
              >
                {allClassData.map((c, i) => (
                  <MenuItem key={i} value={c.classid}>
                    {c.standard} - {c.division}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <StandardButton
              label="Login"
              type="submit"
              loading={btnLoading}
            />
          </form>
        </section>
      </div>
    </IonicPageWrapper>
  );
}

export default Login;
